import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../../pages/Loading/Loading';

const DashboardTracking = lazy(() => import('../../../../../pages/DashboardTracking/DashboardTracking'));

export const Route = createFileRoute('/$lang/_authenticated/dashboard-tracking/$typeView')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <DashboardTracking />
    </Suspense>
  ),
});
